import { render, staticRenderFns } from "./EditPricePackage.vue?vue&type=template&id=79c01945"
import script from "./EditPricePackage.vue?vue&type=script&lang=js"
export * from "./EditPricePackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports